define('lisAserieAddLisAnaView',[
  'module',
  'marionette',
  'backbone',
  'dialogFormView',
  'template!lisAserieAddLisAnaTpl',
  'savingBehavior',
  'bootbox',
  'underscore',
  'app',
  'autocompleteView',
  'entities/lisanas'
], function(
  module,
  Marionette,
  Backbone,
  DialogFormView,
  addLisAnaTpl,
  SavingBehavior,
  bootbox,
  _,
  App,
  AutocompleteView
) {
  'use strict';

  var AddLisAnaView = DialogFormView.extend({
    template: addLisAnaTpl,

    ui: {
      input: '.js-info-input',
      colorBtn: '.colorpick'
    },

    events: {
      'click .js-cancel-popup': 'hide',
      'focus @ui.input' : 'onFocus',
      'change @ui.input': 'onInputChange',
      'click .js-confirm': 'onConfirm'
    },

    regions: {
      lisAnaSelect: '.js-select-lisanas-region'
    },

    behaviors: {
      Saving: {
        behaviorClass: SavingBehavior
      }
    },

    modelEvents: {
      sync: 'onSave',
      error: 'onSaveError'
    },

    fieldsToValidate: [
      {name: 'lisAna', type: 'required'}
    ],

    initialize: function(options) {
      this.model = new Backbone.Model();
      this.lisSecId = options.lisSecId;
      this.lisAserieSecId = options.lisAserieSecId;
    },

    serializeData: function() {
      var templateData = {};
      templateData.newItem = this.options.newItem;
      return templateData;
    },

    onShow: function() {
      $.material.init();

      var lisAnaView = new AutocompleteView(
        this._getAutocompleteOptions('lisAna', 'code', 'code',
          'v2/lis/'+this.lisSecId+'/lisanas',
          'selectlisana.placeholder', 'code')
      );
      this.getRegion('lisAnaSelect').show(lisAnaView);

      this.triggerMethod('enable:cancel:confirm');
    },

    onConfirm: function() {
      if(this.validate(this.fieldsToValidate)) {
        App.request('lisana:create-lisaserie-lisana', this.lisAserieSecId, this.model.get('lisAna')).done(_.bind(function () {
          this.hide();
        }, this));
      }
    },

    onSave: function() {
      this.triggerMethod('saved');
      this.hide();
    },

    hide: function() {
      this.triggerMethod('hide');
      this.box.modal('hide');
      this.destroy();
      if (this.lisAserieSecId && App.getCurrentRoute() ===  'admin/lisaseries/'+this.lisAserieSecId+'/lisana/new') {
        App.navigate('admin/lisaseries/'+this.lisAserieSecId+'/lisana', {trigger: true});
      }
    },

    onSaveError: function(model, response) {
      if(response.status === 409) {
        this.onDuplicateCode();
        this.triggerMethod('hide:label');
      }
    },

    onDuplicateCode: function() {
      this.ui.endUserIdInput.popover('show');
      this.ui.endUserIdInput.addClass('invalid');
      this.ui.endUserIdInput.closest('div[data-field-name=code').addClass('has-error');
    }
  });

  module.exports = AddLisAnaView;
});
